import React, { memo, useEffect, useRef, useState } from "react";
import { isMobile } from "react-device-detect";
import { clearData, getData, storeData } from "../../utils/GlobalHelper";

import HeaderPage from "../../components/HeaderPage/Index";
import Loading from "../../components/loading/loading";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import styles from "../../components/Modal/MoreInfo.module.css";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import clsx from "clsx";

import HeaderRight from "../../components/BoxRightContent/HeaderRight";
const theme = createTheme({
  palette: {
    primary: {
      main: "#003D68",
      accent: "#A7A9AC",
    },
    secondary: {
      main: "#739CD8",
    },
  },
});

const useStyle = makeStyles({
  font: {
    fontFamily: "DB Heavent",
  },
  content: {
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    color: "var(----text-black)",
  },
});

import { CRSConsent } from "../../utils/GlobalKey";
import Configs from "../../constants/Configs";
import GlobalApi from "../../utils/GlobalApi";
import { makeStyles } from "@mui/styles";
import ButtonRight from "../../components/BoxRightContent/ButtonRight";
import { Box } from "@mui/material";
const CRSConsentPage = (props) => {
  const classes = useStyle();
  const translations = getData("Translations");
  const [isLoading, setIsLoading] = useState(false);
  const [lang, setLang] = useState(getData("lang"));
  const [consentData, setConsentData] = useState(null);
  const scrollBarRef = useRef(null);

  // const info = {
  //   title: "การยืนยันและการเปลี่ยนแปลงสถานะและ\n การเปิดเผยข้อมูลและความ\nยินยอมในการหักเงินใน",
  //   details: "ท่านยืนยันว่าข้อความข้างต้นเป็นความจริง ครบถ้วน ถูกต้องและเป็นปัจจุบัน You confirm that this information is true, complete, accurate and current...rhoncus feugiat faucibus bibendum. Neque netus sed nam mauris eget quisque non. Vivamus vulputate urna nibh morbi egestas arcu cursus at. Nullam in sit nisi accumsan risus nunc feugiat. Sapien fermentum pellentesque blandit elementum lorem ac volutpat orci pretium. Tristique at in a lectus auctor proin duis volutpat massa. Tempus lacus elit eu mauris nunc sed. Ac sed blandit in proin lacus ullamcorper tempus a. Placerat posuere neque sed orci a mauris sit. Morbi leo enim adipiscing sed risus enim sit ultrices. Viverra mauris magna nec aliquam tellus nec felis. Ultrices non purus cras vel aliquam at. Habitant pulvinar dictumst a accumsan interdum molestie vitae interdum. Ante bibendum leo ornare sed in aliquet ornare aliquet. Ultrices viverra posuere ac purus curabitur gravida arcu aliquet est. Gravida enim suscipit purus dis et aliquet quisque neque at. Dolor vulputate mi tempor viverra. Sapien pretium amet ut purus felis lectus orci senectus. Quis nunc dignissim at elit facilisi molestie arcu ultrices. Ac sed blandit in proin lacus ullamcorper tempus a. Placerat posuere neque sed orci a mauris sit.",
  //   btnText: "ถัดไป"
  // }
  const [isScrollEnd, setIsScrollEnd] = useState(false);

  const getCRSConsents = async () => {
    setIsLoading(true);
    const header = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    let productCRSId = "crs";
    let getConsentUrl = `${Configs.baseURL}/api/consent?id=${productCRSId}`;
    try {
      await GlobalApi.get(getConsentUrl, header)
        .then(async (res) => {
          setIsLoading(false);
          res?.data?.data.forEach((row) => {
            setConsentData({
              consentName: row.consent_name,
              title: row?.title,
              details: row?.detail,
              btnText: row?.okBtn,
            });
          });
        })
        .catch((er) => {
          console.log(`error : ${er}`);
          setIsLoading(false);
        });
    } catch (error) {
      console.log(`error : ${er}`);
      setIsLoading(false);
    }
  };

  // โหลด Consent ครั้งแรก
  useEffect(() => {
    getCRSConsents();
  }, []);

  const handleScroll = (event) => {
    const target = event.currentTarget;
    let a = target.scrollTop - target.scrollHeight;
    let b = (target.clientHeight + 10) * -1;

    if (a === b || a > b) {
      setIsScrollEnd(true);
    } else {
      setIsScrollEnd(false);
    }
  };

  const handleNextButton = () => {
    storeData(CRSConsent, "true");
    props.history.push("/otp");
  };

  const scrollToElement = (action) => {
    if (action) {
      setTimeout(() => {
        const container = document.getElementById(action);
        container?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100);
    }
  };

  const ScrollToBottom = () => {
    if (scrollBarRef.current) {
      const scrollHeight = scrollBarRef.current.scrollHeight;
      scrollBarRef.current.scrollTo({
        top: scrollHeight,
        behavior: "smooth",
      });
    }
  };

  const clickBack = () => {
    clearData(CRSConsent);
    props.history.push("/declare_location");
  };

  return (
    <>
      <ThemeProvider theme={theme}>
        <HeaderPage
          title={translations?.[lang]?.home?.title}
          onChangeLang={(e) => setLang(e)}
          clickBack={(e) => (e ? clickBack() : "")}
        />
        <Loading status={isLoading} />
        <Grid className="background-bg">
          <Grid className="section-consent">
            <Grid className={isMobile ? "box-content-mb" : "box-content"}>
              <Grid container className="box-content-main" columns={16}>
                {!isMobile && (
                  <Grid item xs={7} className="box-left">
                    <BoxLeftContent
                      translations={translations?.[lang]?.checkuserinfo}
                      clickBack={(e) => clickBack()}
                    />
                  </Grid>
                )}
                <Grid
                  item
                  xs={isMobile ? 16 : 9}
                  className={isMobile ? "box-right-mb" : "box-right"}
                >
                  <Grid className="content">
                    <Grid className="content-main">
                      <Grid
                        className="box-right-content pb-3"
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          height: "100%",
                        }}
                      >
                        {/* Header อยู่นอก scroll area — นิ่งตลอด ไม่เลื่อนตาม */}
                        {consentData && (
                          <Grid className="fullWidth" sx={{ flexShrink: 0 }}>
                            <HeaderRight title={consentData.title} />
                          </Grid>
                        )}

                        {/* เฉพาะส่วนนี้ที่ scroll ได้ */}
                        <Box
                          sx={{
                            flexGrow: 1,
                            minHeight: 0,
                            overflow: "hidden",
                          }}
                        >
                          {consentData && (
                            <div
                              ref={scrollBarRef}
                              className={
                                isMobile
                                  ? styles.containerMobileConsent
                                  : styles.container
                              }
                              onScroll={handleScroll}
                              style={{
                                height: "100%",
                                overflowY: "auto",
                                overflowX: "hidden",
                              }}
                            >
                              <Grid className={classes.content}>
                                <Grid
                                  sx={{ width: "100%" }}
                                  className={clsx(
                                    classes.font,
                                    "font-20 !important",
                                  )}
                                  dangerouslySetInnerHTML={{
                                    __html: consentData.details,
                                  }}
                                />
                              </Grid>
                            </div>
                          )}
                        </Box>

                        {isScrollEnd ? (
                          <ButtonRight
                            id="nextPage"
                            text="ยอมรับ"
                            onNextPage={handleNextButton}
                          />
                        ) : (
                          <ButtonRight
                            id="scrollDown"
                            BtnSecondary
                            text="เลื่อนลงไปล่างสุด"
                            onNextPage={ScrollToBottom}
                          />
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </ThemeProvider>
    </>
  );
};

export default memo(CRSConsentPage);
